import React from 'react';
import { Toast } from 'antd-mobile';

import { getAppId, checkIfLogin } from '@utils/global';
import { ajax } from '@utils/http';
import { appMethod as app } from '@utils/app';

import './LoginPage.less';

// 定时器
let timer = null;
const AREA_CODE = {
  0: '',
  8: '60'
};

export default class LoginPage extends React.Component {
  state = {
    areaCode: 0,
    phoneNumber: '',
    picCode: '',
    picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000),
    identifyCode: '',
    verifying: false,
    time: 60,
    logining: false,
  }
  constructor(props) {
    super(props);
    document.title = '登录';
    if (app.isLogin()) {
      app.turnBack();
    }
  }
  /**
   * 更换图形验证码
   */ 
  getPicCode = () => {
    this.setState({
      picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000)
    })
  }
  /**
   * 获取验证码
   */
  getIdentifyCode = () => {
    if (this.state.verifying) {
      return;
    }
    if (!this.state.phoneNumber) {
      Toast.info('请输入手机号');
      return;
    }
    if (this.state.phoneNumber.includes(' ')) {
      Toast.info('手机号不能有空格');
      return;
    }
    if (!this.state.picCode) {
      Toast.info('请输入图形验证码');
      return;
    }
    this.setState({
      verifying: true,
      time: 60
    });
    const phone = +this.state.areaCode === 0 ? this.state.phoneNumber : `${ AREA_CODE[this.state.areaCode] }-${ this.state.phoneNumber }`;
    ajax({
      url: '/index.php?r=AppUser/phoneCode',
      data: {
        app_id: getAppId(),
        phone,
        pic_code: this.state.picCode,
      },
      success: (res) => {
        if (res.status !== 0) {
          Toast.fail(res.data);
          this.setState({
            verifying: false,
            time: 60
          });
          return;
        }
        timer = setInterval(() => {
          if (this.state.time === 0) {
            clearInterval(timer);
            this.setState({
              verifying: false,
              time: 60
            });
          }
          this.setState({
            time: --this.state.time
          })
        }, 1000);
      }
    })
  }
  /**
   * 处理input的值的更改
   */
  handleChange = (name, event) => {
    this.setState({
      [name]: event.target.value
    });
  }
  /**
   * 登录
   */
  handleLogin = () => {
    if (this.state.logining) {
      return;
    }
    // if (!this.state.phoneNumber) {
    //   Toast.info('请输入手机号');
    //   return;
    // }
    // if (this.state.phoneNumber.includes(' ')) {
    //   Toast.info('手机号不能有空格');
    //   return;
    // }
    // if (!this.state.identifyCode) {
    //   Toast.info('请输入验证码');
    //   return;
    // }
    this.setState({
      logining: true
    });
    const phone = +this.state.areaCode === 0 ? this.state.phoneNumber : `${ AREA_CODE[this.state.areaCode] }-${ this.state.phoneNumber }`;
    ajax({
      url: '/index.php?r=AppUser/phoneReg',
      data: {
        app_id: getAppId(),
        phone,
        code: this.state.identifyCode,
      },
      success: (res) => {
        if (res.status !== 0) {
          this.setState({
            logining: false
          });
          Toast.fail(res.data);
          return;
        }
        app.setIsLogin(true);
        app.bindUserAccount();
        let nickname = res.nickname;
        let cover = res.cover_thumb;
        if (nickname && cover) {
          Toast.info('登录成功', 1);
          // 请求用户数据存到本地
          app.requestUserInfo().then(() => {
            app.turnBack(); // 登录成功返回上一页
          })
          return;
        } else if (!nickname && !cover) {
          Toast.info('登录成功 请补充个人信息');
        } else if (!nickname) {
          Toast.info('登录成功 请补充个人昵称');
        } else if (!cover) {
          Toast.info('登录成功 请补充个人头像');
        }
        app.turnToPage('userCenter'); // 信息不完整则跳到用户信息页面进行补全信息
      },
      error: () => {
        this.setState({
          logining: false
        });
        Toast.fail(res.data);
      }
    })
  }

  /**
   * 微信公众号授权登录
   */
  wxLogin = () => {
    const REDIRECT_URI = 'https://develop.zhichiwangluo.com/zc_webapp/' + app.getHomepageRouter() + '?app_id' + getAppId();
    window.open(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx66578094fccaae32&redirect_uri=${REDIRECT_URI}&response_type=code&scope=SCOPE&state=STATE#wechat_redirect`)
  }

  render() {
    return (
      <div id="loginPage" className="page" >
        <div className="center-wrap">
          <header>即速应用</header>
          <div>
            <p className="phone-wrap">
              <select value={this.state.areaCode} onChange={this.handleChange.bind(this, 'areaCode')}>
                <option value="0">中国大陆+86</option>
                <option value="8">Malaysia+60</option>
              </select>
              <input id="login-phone" className="js-phone-input" type="number" placeholder="请输入手机号" value={this.state.phoneNumber} onChange={this.handleChange.bind(this, 'phoneNumber')}/>
            </p>
            <p className="code-p">
              <input className="pic-code-input" type="text" placeholder="图形验证码" value={this.state.picCode} onChange={this.handleChange.bind(this, 'picCode')}/>
              <img className="pic-code-url" src={this.state.picCodeUrl} onClick={this.getPicCode} />
            </p>
            <p className="code-p">
              <input id="login-code" className="code-input" placeholder="请输入验证码" value={this.state.c} onChange={this.handleChange.bind(this, 'identifyCode')}/>
              <span className="get-code-btn" onClick={this.getIdentifyCode} >{(this.state.verifying && this.state.time !== 60) ? this.state.time + 's' : '获取验证码' }</span>
            </p>
            <div className="lrf-btn" onClick={this.handleLogin}>登录</div>
            <div className="wx-login-btn" onClick={this.wxLogin}>微信授权登录</div>
          </div>
        </div>
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/official-page/login-page/LoginPage.jsx